import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Brain, Target, BarChart3, Gamepad2, CheckCircle } from "lucide-react";
import dashboardPreview from "@/assets/dashboard-preview.png";

const Hero = () => {
  const benefits = [
    { icon: Brain, text: "Crie conteúdos e copies em segundos com IA" },
    { icon: Target, text: "Estruture funis, campanhas e lançamentos sem complicação" },
    { icon: BarChart3, text: "31 planilhas inteligentes integradas ao seu negócio" },
    { icon: Gamepad2, text: "Gamificação para te manter no jogo" },
    { icon: CheckCircle, text: "Comece sem saber nada: metodologia simples e prática" },
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4 text-center">
        <h1 className="text-4xl md:text-6xl font-bold text-foreground mb-6 leading-tight max-w-5xl mx-auto">
          Tudo Que Você Precisa Para Vender Online — Em Um Só Lugar.{" "}
          <span className="text-primary">Descomplicado e Rápido.</span>
        </h1>
        
        <p className="text-xl text-muted-foreground mb-8 max-w-4xl mx-auto leading-relaxed">
          A plataforma brasileira que combina <span className="font-semibold text-foreground">IA + Planilhas Inteligentes + Estratégias Prontas</span>{" "}
          para transformar iniciantes em profissionais de marketing com resultados reais.
        </p>

        {/* Benefits List */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto mb-10">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="flex items-start gap-3 text-left p-4 rounded-lg bg-card hover:bg-accent/50 transition-colors"
            >
              <benefit.icon className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
              <span className="text-foreground text-sm md:text-base">{benefit.text}</span>
            </div>
          ))}
        </div>

        <div className="flex flex-col items-center gap-4 mb-4">
          <Button variant="cta" size="lg" className="text-lg px-8 py-6 h-auto" asChild>
            <Link to="/auth">
              👉 Testar Grátis Agora
            </Link>
          </Button>
          <p className="text-sm text-muted-foreground">
            Sem cartão de crédito • Cancela quando quiser
          </p>
        </div>

        {/* Dashboard Preview */}
        <div className="mt-12 max-w-6xl mx-auto">
          <div className="bg-gradient-to-br from-primary/10 via-secondary/10 to-accent/10 rounded-2xl p-8 shadow-lg border border-border">
            <img 
              src={dashboardPreview} 
              alt="MarketPro Tools Dashboard" 
              className="w-full rounded-lg shadow-xl"
            />
            <p className="text-muted-foreground text-lg text-center mt-4">
              🖥️ Dashboard • Chat IA • Planilhas Inteligentes
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
